import configuration from "flash-notifications/build/configuration.js"
import I18n from "shared/i18n"

configuration.translate = (...args) => I18n.t(...args)
